'use client'

import { Suspense } from 'react'
import dynamic from 'next/dynamic'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import WebsocketChannels from '../../components/WebsocketChannels'

type Props = {
  websocketHostUrl: string
}

const Inbox = dynamic(() => import('../Inbox').then(module => module.default), {
  ssr: false,
})

const InboxWithLocation = ({ websocketHostUrl }: Props) => {
  const { href } = useBrowserNavigation()
  const shouldDisableWebsockets = useFeatureSwitch('web_for_testing_server_sent_events')

  return (
    <Suspense fallback={null}>
      <Inbox
        websocketHostUrl={websocketHostUrl}
        location={href}
        renderWebsocketChannels={({ websocketHostUrl: hostUrl }) =>
          shouldDisableWebsockets ? null : <WebsocketChannels websocketHostUrl={hostUrl} />
        }
      />
    </Suspense>
  )
}

export default InboxWithLocation
